
import { Modal } from 'bootstrap';
import { defineComponent, ref, inject, watchEffect, onMounted } from 'vue';
import { Apollo, Notify } from '@/core/services';
import { Input, Select } from '@/components/input-elements';
import { AddAddress } from '../interfaces/index';
import { GET_COUNTRIES } from '@/modules/common/countries/graphql/Queries';
import { formatCountryLabel } from '@/modules/common/countries/countryHelper';
import { CREATE_CUSTOMER_ADDRESS } from '../graphql/Mutations';
import { GET_CUSTOMER_ADDRESSES } from '../graphql/Queries';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import InnerLoader from '../../../../components/InnerLoader.vue';
import VueGoogleAutocomplete from 'vue-google-autocomplete';

export default defineComponent({
    name: 'add new address',
    props: {
        customerData: Object
    },
    components: {
        Input,
        Select,
        VueGoogleAutocomplete,
        InnerLoader
    },

    setup(props) {
        const store = useStore();
        const modal: any = ref();
        const loading = ref(false);
        const address_1Ref = ref();
        const emitter: any = inject('emitter');
        const addAddressForm = ref<null | HTMLFormElement>(null);
        const countries = ref([]) as Record<any, any>;
        const route = useRoute();
        const i18n = useI18n();
        const loader = store.getters.appInstance;
        // Get Countries
        const getCountries = () => {
            countries.value = [];
            const countriesData = Apollo.readQuery({
                query: GET_COUNTRIES
            });

            const country = [] as Record<any, any>;
            countriesData.countries.forEach(element => {
                country.push({
                    label: formatCountryLabel(element.name),
                    value: element.id,
                    locale: element.locale,
                    currency: element.currency
                });
            });

            countries.value = country;
        };

        const address = ref<AddAddress>({
            name: '',
            company: '',
            phone_number: '',
            address_1: '',
            address_2: '',
            city: '',
            postal_code: '',
            country_id: null,
            customer_id: null,
            default_payment: false,
            default_shipping: false
        });

        const resetForm = () => {
            getCountries();
            emitter.emit('clearInput');
            address.value.address_1 = '';
            address.value.address_2 = '';
            addAddressForm.value?.resetFields();
        };

        const handlerSubmitForm = () => {
            addAddressForm.value?.validate(async (valid: boolean) => {
                if (valid) {
                    const formData = {
                        uuid: String(route.params.uuid),
                        name: address.value.name,
                        company: address.value.company,
                        city: address.value.city,
                        address_1: address.value.address_1,
                        address_2: address.value.address_2,
                        postal_code: address.value.postal_code,
                        phone_number: address.value.phone_number,
                        country_id: address.value.country_id,
                        customer_id: address.value.customer_id,
                        default_payment: address.value.default_payment == true ? 1 : 0,
                        default_shipping: address.value.default_shipping == true ? 1 : 0
                    };
                    // loader.$loading();
                    loading.value = true;
                    await Apollo.mutate({
                        mutation: CREATE_CUSTOMER_ADDRESS,
                        variables: { input: formData },
                        update: (store, { data: { create_address } }) => {
                            // const pervious_record = store.readQuery({
                            //     query: GET_CUSTOMER_ADDRESSES,
                            //     variables: {
                            //         uuid: String(route.params.uuid),
                            //         page: 1,
                            //         limit: 5
                            //     }
                            // }) as Record<any, any>;

                            // store.writeQuery({
                            //     query: GET_CUSTOMER_ADDRESSES,
                            //     variables: {
                            //         page: 1,
                            //         limit: 5,
                            //         uuid: String(route.params.uuid)
                            //     },
                            //     data: {
                            //         customer_addresses: {
                            //             ...pervious_record.customer_addresses,
                            //             data: [create_address, ...pervious_record.customer_addresses.data]
                            //         }
                            //     }
                            // });
                            loading.value = false;
                            modal.value.hide();
                            Notify.success(`${i18n.t('message.RECORD_ADDED_SUCCESSFULLY')}`);
                            emitter.emit('closeEditAddressModal');
                        }
                    }).catch(() => {
                        loading.value = false;
                    });
                }
            });
        };

        watchEffect(async () => {
            address.value.country_id = await props?.customerData?.user?.country?.id;
        });

        // Emitter To Open Model
        emitter.on('addAddressAction', () => {
            resetForm();
            address.value.address_1 = '';
            modal.value = new Modal(document.getElementById('modal_add_address')) as HTMLElement;
            modal.value.show();
        });

        const setPlace_1 = (addres, placeResultData) => {
            addres.country == 'Danmark' || addres.country == 'Denmark' ? (addres.country = 'Danmark') : addres.country == 'Garmany' || addres.country == 'Germany' ? (addres.country = 'Germany') : '';

            const found = countries.value.find(ele => ele.label === formatCountryLabel(addres.country));

            if (found) {
                address.value.country_id = addres?.country ? found.value : '';
                address.value.city = addres?.locality ? addres?.locality : '';
                address.value.postal_code = addres?.postal_code ? addres.postal_code : '';
                address.value.address_1 = addres?.route ? addres?.route + ' ' : '';
                address.value.address_1 ? (address.value.address_1 = addres?.street_number ? address.value.address_1 + addres?.street_number : address.value.address_1) : '';
            } else {
                address.value.address_1 = '';
                address.value.city = '';
                address.value.postal_code = '';
                Notify.error(`${i18n.t('message.WE_CANT_OPERATE_IN')} ${addres.country}`);
            }
        };

        const setPlace_2 = (addres, placeResultData) => {
            addres.country == 'Danmark' || addres.country == 'Denmark' ? (addres.country = 'Danmark') : addres.country == 'Garmany' || addres.country == 'Germany' ? (addres.country = 'Germany') : '';

            const found = countries.value.find(ele => ele.label === formatCountryLabel(addres.country));

            if (found) {
                address.value.address_2 = addres?.route ? addres?.route + ' ' : '';
                address.value.address_2 ? (address.value.address_2 = addres?.street_number ? address.value.address_2 + addres?.street_number : address.value.address_2) : '';
            } else {
                address.value.address_2 = '';
                Notify.error(`${i18n.t('message.WE_CANT_OPERATE_IN')} ${addres.country}`);
            }
        };

        return {
            address,
            countries,
            addAddressForm,
            loading,
            handlerSubmitForm,
            setPlace_1,
            setPlace_2,
            address_1Ref
        };
    }
});
